import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c3-three-three-two',
  templateUrl: './c3-three-three-two.component.html',
  styleUrls: ['./c3-three-three-two.component.scss']
})
export class C3ThreeThreeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
